import React, { useState, useEffect, useRef, useReducer } from 'react';
import { getsystemlis, setsdmlist } from '../../utils/api'
import { useTranslation } from 'react-i18next'
import { List, DateSelect, Button } from 'zarm';
import { Link, useNavigate } from 'react-router-dom'
import { Toast } from 'zarm';

const Country: React.FC = () => {

  const { t } = useTranslation()

  const [list, setlist] = useState([]) as any

  const setRegion = async () => {
    await setsdmlist().then((res) => {
      setlist(res.rows)
      res.rows.forEach((element:any) => {
        console.log(element.sdmUserId)
      });
    })
  }

  
  const Toasts = async () => {
    Toast.show('No public activities yet');
  }
  // 

  const [show, setshow] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0);
    setRegion()
  }, []);


  return <div style={{ color: '#fff', textAlign: 'center', padding: '20px' }}>
    <div style={{ padding: '20px', fontSize: '24px', fontWeight: '700', cursor: 'pointer' }} onClick={() => setshow(!show)}>
      User List（Delete after testing）
    </div>
    <div style={{ fontSize: '14px', marginTop: '10px' }}>{
      list.map((item: any, index: any) => <div>
        {
          item.eventOpen == 0 ? <Link to={`/MyEvents2?id=${item.sdmUserId}`} key={index} style={{
            display: 'flex', flexDirection: 'row',
            marginLeft: '20px', marginRight: '20px', marginTop: 5, marginBottom: 10, backgroundColor: '#2F3237', borderRadius: 10,
            justifyContent: 'space-between', alignItems: 'center', height: '64px'
          }}>

            <div style={{ display: 'flex', flexDirection: 'row', margin: '8px', alignItems: 'center' }} >
              <img src={item.imgUrl} style={{
                width: '48px', height: '48px', borderColor: '#a2a2a2',
                borderWidth: 4, borderRadius: 8
              }} ></img>

              <div style={{ marginLeft: 10 }}>
                <div style={{ fontWeight: 500, fontSize: '16px', color: '#FFFFFF', height: '24px', lineHeight: '24px' }}>
                  {item.sdmUserName}
                </div>
                {
                  item.walletDdressEtamask ? <div style={{ fontWeight: 400, fontSize: '14px', color: '#B1B5C1', height: '24px', lineHeight: '24px' }}>
                    {item.walletDdressEtamask.toString().slice(0, 4)}...{item.walletDdressEtamask.toString().slice(item.walletDdressEtamask.toString().length - 4, item.walletDdressEtamask.toString().length)}

                  </div> : <div style={{ fontWeight: 400, fontSize: '14px', color: '#B1B5C1', height: '24px', lineHeight: '24px' }}>
                    {''}
                  </div>
                }

              </div>
            </div>
            {
              <div style={{ marginRight: 10 }} >
                <div style={{ backgroundColor: '#000', opacity: 0.5, height: '30px', borderRadius: '15px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <div style={{ color: '#FFF', lineHeight: '30px', fontSize: '15px', marginRight: 8, marginLeft: 8 }}>Open</div>
                </div>
              </div>
            }
          </Link> : <div key={index} style={{
            display: 'flex', flexDirection: 'row',
            marginLeft: '20px', marginRight: '20px', marginTop: 5, marginBottom: 10, backgroundColor: '#2F3237', borderRadius: 10,
            justifyContent: 'space-between', alignItems: 'center', height: '64px'
          }}  onClick={()=>Toasts()}>

            <div style={{ display: 'flex', flexDirection: 'row', margin: '8px', alignItems: 'center' }} >
              <img src={item.imgUrl} style={{
                width: '48px', height: '48px', borderColor: '#a2a2a2',
                borderWidth: 4, borderRadius: 8
              }} ></img>

              <div style={{ marginLeft: 10 }}>
                <div style={{ fontWeight: 500, fontSize: '16px', color: '#FFFFFF', height: '24px', lineHeight: '24px' }}>
                  {item.sdmUserName}
                </div>
                {
                  item.walletDdressEtamask ? <div style={{ fontWeight: 400, fontSize: '14px', color: '#B1B5C1', height: '24px', lineHeight: '24px' }}>
                    {item.walletDdressEtamask.toString().slice(0, 4)}...{item.walletDdressEtamask.toString().slice(item.walletDdressEtamask.toString().length - 4, item.walletDdressEtamask.toString().length)}

                  </div> : <div style={{ fontWeight: 400, fontSize: '14px', color: '#B1B5C1', height: '24px', lineHeight: '24px' }}>
                    {''}
                  </div>
                }

              </div>
            </div>
            {
              <div style={{ marginRight: 10 }} >
                <div style={{ backgroundColor: '#000', opacity: 0.5, height: '30px', borderRadius: '15px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <div style={{ color: '#FFF', lineHeight: '30px', fontSize: '15px', marginRight: 8, marginLeft: 8 }}>Unpublished</div>
                </div>
              </div>
            }
          </div>
        }
      </div>
      )

    }</div>
  </div>

};






export default Country;